import { RequiredPermissions, pathPermissions } from 'features/validateAccess';
import { TFunctionArgument, UIType } from 'shared/declarations/i18n';

import { pathKeys } from 'shared/lib/react-router';

interface INavItem {
  path: string;
  captionID: TFunctionArgument<UIType, 'UI:'>;
  id: string;
  requiredPermissions: RequiredPermissions;
  children?: INavItem[];
}

export const navItems: INavItem[] = [
  {
    path: pathKeys.dashboard(),
    captionID: 'UI:MainNav.menuItem.dashboard',
    id: 'dashboard',
    requiredPermissions: pathPermissions.dashboard,
  },
  {
    path: pathKeys.account.root(),
    captionID: 'UI:MainNav.menuItem.accounts',
    id: 'accounts',
    requiredPermissions: pathPermissions.account.root,
  },
  {
    path: pathKeys.userOverview(),
    captionID: 'UI:MainNav.menuItem.userOverview',
    id: 'user-overview',
    requiredPermissions: pathPermissions.userOverview,
  },
  {
    path: pathKeys.timesheets(),
    captionID: 'UI:MainNav.menuItem.timesheets',
    id: 'timesheets',
    requiredPermissions: pathPermissions.timesheets,
  },
  {
    path: pathKeys.calendars.root(),
    captionID: 'UI:MainNav.menuItem.calendars',
    id: 'calendars',
    requiredPermissions: pathPermissions.calendars.root,
  },
  {
    captionID: 'UI:MainNav.menuItem.administration',
    path: '#',
    id: 'administration',
    requiredPermissions: pathPermissions.administration.root,
    children: [
      {
        path: pathKeys.administration.countries(),
        captionID: 'UI:MainNav.menuItem.countries',
        id: 'countries',
        requiredPermissions: pathPermissions.administration.countries,
      },
      {
        path: pathKeys.administration.accessGroups(),
        captionID: 'UI:MainNav.menuItem.accessGroups',
        id: 'access-groups',
        requiredPermissions: pathPermissions.administration.accessGroups,
      },
    ],
  },
];
